import { render, staticRenderFns } from "./wechatAuthAccount.vue?vue&type=template&id=671295a3&scoped=true"
import script from "./wechatAuthAccount.vue?vue&type=script&lang=js"
export * from "./wechatAuthAccount.vue?vue&type=script&lang=js"
import style0 from "./wechatAuthAccount.vue?vue&type=style&index=0&id=671295a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671295a3",
  null
  
)

export default component.exports